module.exports = __webpack_public_path__ + "assets/img/Kitome-Blog-w540.7ce0b6df.webp";